module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/warning-icon-f7aba6fd115e3eddf07bb4db6cbd40a4.svg";